import { useEffect, useState } from "react"
import Api from "../api/api"
import arrayUtilities from "../../utilities/arrayUtilities"
import { SiteGroupSelection } from "./siteGroupSelection"
export const ClientSelection = ({ organisationId, token, client, isClientChecked, onClientCheckboxChange, toggleSiteId, toggleSiteGroup, removeMultipleSiteGroups, removeMultipleSites, userAssignedSites, userSiteGroups }) => {

    const [sitesByClient, setSitesByClient] = useState(null)
    const [showSiteSelection, setShowSiteSelection] = useState(false)
    const [isRestrictSitesChecked, setIsRestrictSitesChecked] = useState(false)

    const selectedSites = arrayUtilities.isNullOrEmpty(sitesByClient)
        ? []
        : sitesByClient.reduce((acc, site) => {
            if (userAssignedSites.includes(site.id)) {
                acc.push(site.id)
            }
            return acc
        }, [])

    const removeSitesAndTheirSiteGroups = (siteIdsToRemove) => {
        if (!arrayUtilities.isNullOrEmpty(siteIdsToRemove)) {
            removeMultipleSites(siteIdsToRemove)
            Api.getAllSiteGroups(
                organisationId,
                data => {
                    if (!arrayUtilities.isNullOrEmpty(data)) {
                        const siteGroupIdsToRemove = data.reduce((acc, item) => {
                            if (siteIdsToRemove.includes(item.siteId)) {
                                acc.push(item.id)
                            }
                            return acc
                        }, [])
                        removeMultipleSiteGroups(siteGroupIdsToRemove)
                    }
                },
                error => console.log(error),
                token
            )
        }
    }

    const handleClientCheckboxChange = (event) => {
        onClientCheckboxChange(event)
        if (!event.target.checked) {
            removeSitesAndTheirSiteGroups(selectedSites)
            setSitesByClient(null)
            setShowSiteSelection(false)
            setIsRestrictSitesChecked(false)
        }
    }

    useEffect(() => {
        if (isClientChecked) {
            Api.getClientSites(
                data => {
                    if (!arrayUtilities.isNullOrEmpty(data)) {
                        setSitesByClient(data)
                        setShowSiteSelection(true)
                        if (data.some(site => userAssignedSites.includes(site.id))) {
                            setIsRestrictSitesChecked(true)
                        }
                    } else {
                        setShowSiteSelection(false)
                        setSitesByClient(null)
                        setIsRestrictSitesChecked(false)
                    }
                },
                error => {
                    setShowSiteSelection(false)
                    setSitesByClient(null)
                },
                client.id, organisationId, token
            )
        }
        
    }, [isClientChecked, client.id])

    return (
        <div>
            <div className="custom-control custom-checkbox">
                <input
                    className="custom-control-input"
                    type="checkbox"
                    checked={ isClientChecked }
                    id={ `client-${ client.id }` }
                    onChange={ event => handleClientCheckboxChange(event) }
                />
                <label className="custom-control-label col-form-label col-form-label-sm" htmlFor={ `client-${ client.id }` }>{ client.name }</label>
            </div>
            {
                showSiteSelection &&
                <div className="ml-1 d-flex align-items-start">
                    <i className="fas fa-level-up-alt rotate-90 mr-2"></i>
                    <div className="border bg-white rounded-md p-2">
                        <div className="d-flex flex-column">
                            <p className="font-weight-semi-bold m-0 fs--1">Restrict access to specific sites</p>
                            <div className='custom-control custom-switch align-items-center'>
                                <input className="custom-control-input" type="checkbox" id={ `${ client.id }-site-switch` } checked={ isRestrictSitesChecked } onChange={ e => {
                                    setIsRestrictSitesChecked(e.target.checked)
                                    if (!e.target.checked) {
                                        removeSitesAndTheirSiteGroups(selectedSites)
                                    }
                                } } />
                                <label className="custom-control-label custom-toggle" htmlFor={ `${ client.id }-site-switch` }></label><p className="m-0 mt-1 fs--1">{ isRestrictSitesChecked ? <>Yes - User can only access the following sites</> : <>No - User can access all sites</> }</p>
                            </div>
                        </div>
                        <div className="pr-3 ml-3 mt-2">
                            {
                                isRestrictSitesChecked && !arrayUtilities.isNullOrEmpty(sitesByClient) && sitesByClient.map(
                                    site => <SiteGroupSelection
                                        organisationId={ organisationId }
                                        token={ token }
                                        site={ site }
                                        siteIds={ selectedSites }
                                        toggleSiteId={ toggleSiteId }
                                        toggleSiteGroup={ toggleSiteGroup }
                                        key={ site.id }
                                        removeMultipleSiteGroups={ removeMultipleSiteGroups }
                                        userSiteGroups={ userSiteGroups }
                                        isRestrictSitesChecked={ isRestrictSitesChecked }
                                        isSiteChecked={selectedSites.includes(site.id)}
                                    />
                                )
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}